/**
 * Platform duplicate label: "{source} - Duplicate" with optional max length.
 * Same contract as server/utils/duplicateLabel.js.
 */

export const DUPLICATE_SUFFIX = ' - Duplicate';

/**
 * @param {string} text
 * @param {{ maxLength?: number, fallback?: string }} [options]
 */
export function buildDuplicateLabel(text, options = {}) {
  const { maxLength, fallback = 'Item' } = options;
  const base = text != null ? String(text).trim() : '';
  const source = base || fallback;
  let label = `${source}${DUPLICATE_SUFFIX}`;
  if (typeof maxLength === 'number' && maxLength > 0 && label.length > maxLength) {
    const maxSourceLen = maxLength - DUPLICATE_SUFFIX.length;
    if (maxSourceLen <= 0) {
      return DUPLICATE_SUFFIX.slice(-maxLength).trimStart();
    }
    label = `${source.slice(0, maxSourceLen)}${DUPLICATE_SUFFIX}`;
  }
  return label;
}
